import * as qs from 'query-string';
import { preprocessResponse } from 'ha/utils/preprocessResponse';
import { FetchClient } from 'ha/helpers/FetchClient';
import { HermesResponse } from 'ha/modules/Hermes';

export interface HermesLoadOptions {
  includeData?: boolean;
}

export function makeHermesService(fetchClient: FetchClient) {
  return {
    load: (
      pathname: string,
      options?: HermesLoadOptions,
    ): Promise<HermesResponse> => {
      const encodedUrl = encodeURIComponent(pathname);

      return fetchClient
        .fetch(`/api/v1/resource/${encodedUrl}?${qs.stringify(options || {})}`)
        .then(preprocessResponse);
    },
  };
}
